import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Header } from 'semantic-ui-react';
import styled from 'styled-components';

import * as constants from '@/constants';
import { Subscription } from '@/types/subscriptions/subscription';
import { SorterContainer } from '@/components/pages/Service/Detail/NONGLS/Sorter';
import { SubscriptionListContents } from '@/components/pages/Service/Detail/NONGLS/SubscriptionListContents';
import { isTransferredServiceGroupId } from '@/components/pages/Service/Detail/NONGLS/Root/util';

type Props = {
  subscriptions: Subscription[];
  isLoading: boolean;
  serviceGroupID: number;
};

export const SubscriptionListRoot: React.FC<Props> = ({
  subscriptions,
  isLoading,
  serviceGroupID,
}) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Container text={true}>
        <Styled>
          {!isTransferredServiceGroupId(serviceGroupID) && (
            <InnerWrapper>
              <Horizontal>
                <div>
                  <StyledHeader>
                    {t('pages.subscription.index.title')}
                  </StyledHeader>
                  <div className="subscription-index-sub-header">
                    {t('ui.subscription.update_cancel_deadline_note', {
                      num: constants.INTERVAL_BUSINESS_DAYS + 1,
                    })}
                    <br />
                    {t('ui.subscription.load_delay_note')}
                  </div>
                </div>
                <Conditions>
                  <SorterContainer />
                </Conditions>
              </Horizontal>
              <SubscriptionListContents
                subscriptions={subscriptions}
                isLoading={isLoading}
              />
            </InnerWrapper>
          )}
        </Styled>
      </Container>
    </Wrapper>
  );
};

const StyledHeader = styled(Header)`
  &&& {
    margin: 2em 0 1em;
    font-size: 1.5em;
  }
`;

const Wrapper = styled.div`
  .ui.text.container {
    max-width: none !important;
    flex: 1 0 auto;
    width: 930px;
    padding: 0 0 48px;
  }
`;

const Horizontal = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Conditions = styled.div`
  align-self: flex-end;
  display: flex;

  & > *:not(:last-child) {
    margin-right: 16px;
  }
`;

const InnerWrapper = styled.div`
  position: relative;
`;

const Styled = styled.div`
  .subscription-index-sub-header {
    color: rgba(0, 0, 0, 0.4);
    margin: -10px 0 0;
  }
`;
